<template>
  <div class="tile-selector">
    <div class="row justify-content-center">
      <div
        class="col-lg-6 device-tile-col"
        v-for="(item, idx) in normalizedItems"
        :key="idx"
      >
        <div
          tabindex="0"
          :id="`tile_question-${question.number}-value-${item.value}`"
          v-on:click="handleSelect(item.value)"
          v-on:keyup.enter="handleSelect(item.value)"
          :class="{'device-tile': true, 'tile-selected': item.value === value}"
          :style="{color: theme.primaryColor, borderColor: item.value === value ? theme.primaryColor : '#d6dadd'}"
        >
          <div class="device-tile-content">
            <i
              v-if="item.icon"
              class="fa device-type-icon"
              v-bind:class="item.icon"
              aria-hidden="true"
            />

            <svg
              v-else-if="item.svgSrc"
              :alt="item.alt"
              :style="{fill: theme.primaryColor}">
            <use :xlink:href="`${item.svgSrc}#${item.svgId}`"></use>
            </svg>

            <img
              v-else-if="item.imgSrc"
              :src="item.imgSrc"
              :alt="item.alt" />

            <h4 v-if="item.displayTitle">{{ item.displayTitle }}</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="margin-bottom: 42px">
      <p
        v-if="help"
        class="tile-selector--help"
      >
        <a :href="helpLink" target="_blank" :style="{ color: theme.primaryColor }">{{ $t('byodHelp') }}</a>
      </p>
    </div>
    <div class="row"
    v-for="(item, idx) in normalizedItems"
        :key="idx">
      <p
        v-if="item.disclaimer"
        class="tile-selector--disclaimer"
      >{{ item.disclaimer }}</p>
    </div>
  </div>
</template>

<script>
import defaultTheme from '../../styles/defaultTheme';

export default {
  name: 'tile-selector',
  props: {
    question: {
      type: Object,
      validator: prop => prop.items && prop.items.every(e => String(e) === '[object Object]' && e.value != null),
      required: true,
    },
    value: {
      type: String,
      default: '',
      required: true,
    },
    readonly: Boolean,
  },
  inject: {
    theme: { default: defaultTheme },
    customer: 'customer',
    program: 'program',
  },
  data() {
    return {
      // TODO: remove logic supporting backwards compatibility: some commonSettings keys moved to program level in programSettings
      // https://github.com/virtual-peaker/product-vp/issues/3571
      helpLink: (this.program.programSettings.find(({ key }) => key === 'byodHelp')
      || (this.customer.commonSettings || []).find(({ key }) => key === 'byodHelp')
      || { url: this.customer.helpLink || 'https://support.virtualpeaker.io' }).url,
    };
  },
  computed: {
    help() {
      return (this.question.help ? this.question.help : false);
    },
    disclaimer() {
      return (this.question.disclaimer ? this.question.disclaimer : false);
    },
    normalizedItems() {
      if (!this.question.items) return [];

      return this.question.items.map(i => ({
        ...i,
        displayTitle: this.getDisplayTitle(i),
      }));
    },
  },
  methods: {
    getDisplayTitle(item) {
      if (item.name) return item.name;
      if (!item.icon && !item.imgSrc && !item.svgSrc) return item.value;
      return null;
    },
    handleSelect(value) {
      if (!this.readonly) {
        if (window.analyticsInitialized) {
          setTimeout(() => {
            const label = `${this.question.name || this.question.model}_${value}`;
            this.$gtag.event('select_tile', {
              event_category: 'engagement',
              event_label: label,
              value: this.question.number,
            });
          }, 100);
        }
        this.$emit('input', value);
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../styles/styles.scss';

.tile-selector {
  .row {
    padding-left: 10px;
  }

  .tile-selector--help {
    margin-top: 8px;
    text-align: center;
    @media (max-width: 576px) {
      margin-right: 32px;
    }
    a {
      text-decoration: underline;
    }
  }
  .tile-selector--disclaimer {
    font-family: Mulish;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;

    color: #AFAFAF;
  }
  &[data-vv-name="deviceData.model"] {
    .row {
      flex-direction: column;

      .device-tile-col {
        max-width: 100%;

        .device-tile {
          max-width: 100%;
          width: 650px;
          height: 112px;

          .device-tile-content {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            width: 100%;
            gap: 60px;
            margin: 0px 30px;

            h4 {
              margin: 0px;
            }
          }
        }
      }
    }

    img {
      height: 71px;
      width: 71px;
      border-radius: 15px;
    }
  }
}

.device-tile-col{
  padding: 15px;

  @media (max-width: 576px) {
    width: 100%;
    padding: 0;
  }

}
.device-tile{
  width: 263.4px;
  height: 263.6px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 1px 1px 0 #dae0e3;
  border-style: solid;
  border-width: 1px;
  border-color: #d6dadd;
  margin: 10px auto 10px auto;
  display: table-cell;
  vertical-align: middle;
  @media (max-width: 576px) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: unset;
    min-height: 130px;
    padding: 0;
    margin: 4px auto 4px auto;
  }

  h4 {
    margin-top: 10px;
    margin-bottom: 30px;
    font-size: 16px;
    color: #4F4F4F;
  }
}
.device-tile-content {
  width: 263.4px;
  text-align: center;
  margin:auto;
  height: 100%;
  display: table-cell;
  @media (max-width: 576px) {
    height: unset;
    margin-top: 16px;
    margin-bottom: 10px;
  }
}
.device-tile-content img {
  width: 80%;
  max-height: 240px;
  @media (max-width: 576px) {
    width: unset;
    max-width: 80%;
    max-height: 100px;
  }
}
#tile_question-2-value-teslaExternalEnroll {
  img {
    max-width: 40%;
    @media (max-width: 576px) {
      max-width: 40%;
    }
  }
}
#tile_question-2-value-tesla {
  img {
    max-width: 60%;
    @media (max-width: 576px) {
      max-width: 60%;
    }
  }
}

.device-tile:hover {
  background-color: #f7f7f7;
  cursor: pointer;
}
.device-type-icon {
  font-size: 3em !important;
}
.tile-selected {
  border-width: 2px;
}
.device-tile-content {
  svg {
    width: 48px;
    height: 48px;
    @media (min-width: 768px) {
      width: 54.5px;
      height: 54.5px;
    }
    @media (min-width: 992px) {
      width: 60px;
      height: 60px;
    }
  }
}

</style>
